import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useStoreActions } from "easy-peasy";
import { signInWithMicrosoftPopup } from "../lib/microsoft-oauth";
import { authenticateWithMicrosoft } from "../api/microsoft-auth";
import { notifyError } from "../lib/notifications";
import {
  saveDoorkeeperParamsFromUrl,
  useOAuthRedirectSave,
} from "../lib/oauth-redirect-storage";
import { redirectAfterLogin } from "../lib/redirect-after-login";
import { MicrosoftIcon } from "./MicrosoftIcon";
import { LoadingSpinner } from "./LoadingSpinner";
import { SecondaryButton } from "./SecondaryButton";

export const SignInWithMicrosoft = () => {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const { saveRedirectFromUrl } = useOAuthRedirectSave();
  const setIsAuthenticated = useStoreActions(
    (actions) => actions.setIsAuthenticated,
  );

  const handleSignIn = async () => {
    try {
      setIsLoading(true);

      saveRedirectFromUrl();

      // If we're on /oauth/authorize (the Doorkeeper / ELMO flow), stash the
      // Doorkeeper params so we can resume the OAuth handshake after the
      // social sign-in round-trip. No-op for the plain /login flow.
      saveDoorkeeperParamsFromUrl();

      const { code, codeVerifier } = await signInWithMicrosoftPopup();
      await authenticateWithMicrosoft({ code, codeVerifier });

      setIsAuthenticated(true);
      redirectAfterLogin(history);
    } catch (error) {
      console.error("Microsoft sign-in error:", error);

      if (error.response?.data?.error === "account_not_connected") {
        history.push("/account-not-connected");
      } else if (error.message === "Authentication cancelled") {
        setIsLoading(false);
      } else {
        notifyError(
          error.response?.data?.message ||
            error.message ||
            "Failed to sign in with Microsoft. Please try again.",
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <SecondaryButton
      onClick={handleSignIn}
      disabled={isLoading}
      className="mb-2 w-full py-3 flex items-center justify-center"
    >
      {isLoading ? (
        <>
          <LoadingSpinner className="h-5 w-5" />
          Signing in...
        </>
      ) : (
        <>
          <MicrosoftIcon className="w-5 h-5" />
          Sign in with Microsoft
        </>
      )}
    </SecondaryButton>
  );
};
